<script setup lang="ts">
import QueueDisplayPage from "@/modules/queue/pages/QueueDisplayPage.vue";

definePage({
  meta: {
    layout: "blank",
    public: true,
  },
});
</script>

<template>
  <QueueDisplayPage />
</template>
